module.exports = __webpack_public_path__ + "img/6.cc1dbdf2.jpg";